import { render, staticRenderFns } from "./TargetScoringDefinitionList.vue?vue&type=template&id=a997febe&scoped=true"
import script from "./TargetScoringDefinitionList.vue?vue&type=script&lang=js"
export * from "./TargetScoringDefinitionList.vue?vue&type=script&lang=js"
import style0 from "./TargetScoringDefinitionList.vue?vue&type=style&index=0&id=a997febe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a997febe",
  null
  
)

export default component.exports